<template>
    <div class="wake-up">
        <span></span>
        <p>Opening All Football...</p>
    </div>
</template>
<style>
    html,body{
        height: 100%;
        background: #212a36;
        color: #fff;
    }
    .wake-up{
        height: 100px;
        width: 100%;
        text-align: center;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
    }
    .wake-up span{
        display: inline-block;
        width: 50px;
        height: 50px;
        background: url(../assets/clock.png) no-repeat;
        background-size: 100%;
    }
    .wake-up p{
        margin: 10px 0;
    }
</style>
<script>
    if (process.env.VUE_ENV !== 'server') {
        const st = (new Date()).getTime();
        location.href = 'allfootball://';
        setTimeout(() => {
            const et = (new Date()).getTime();
            if (et - st > 2900 && et - st < 4000) {
                let utilObj  = require('@/util/util.js');
                utilObj.jumpUrl(true);
            }
        }, 3000);
    }
</script>



// WEBPACK FOOTER //
// AppWakeUp.vue?178fb694